import at from '../actionTypes'
import createReducer from './utilities/createReducer'
import searchTypes from '../../enums/searchTypes'


// TODO: could simplify this and/or feed by making the data structures the same shape
export default createReducer({}, {
	[at.searchParametersClear]: state => ({
		...state,
		searchQuery: '',
		searchType: searchTypes.EVERYTHING.type,
		searchItemResults: undefined,
		searchKitResults: undefined,
		searchUserResults: undefined
	}),
	[at.searchTypeSet]: (state, action) => ({
		...state,
		searchType: action.payload.searchType
	}),
	[at.searchDisplayModeSet]: (state, action) => ({
		...state,
		searchDisplayMode: action.payload.displayMode
	}),
	[at.searchItem_Begin]: (state, action) => ({
		...state,
		searchQuery: action.payload.query,
		searchFacet: action.payload.facet,
		searchItemLoading: true,
		searchLoading: true
	}),
	[at.searchItem_Success]: (state, action) => {
		const searchItemResults = action.payload ? action.payload.hits : []
		const payloadQuery = action.payload ? action.payload.query : null
		//	Skip invalid results
		if (payloadQuery !== state.searchQuery) {
			return state
		}

		return {
			...state,
			searchItemResults,
			searchItemLoading: false,
			searchLoading: state.searchKitLoading || state.searchUserLoading
		}
	},
	[at.searchItem_Fail]: (state, action) => ({
		...state,
		searchItemError: action.payload.searchItemError,
		searchItemLoading: false,
		searchLoading: state.searchKitLoading || state.searchUserLoading
	}),

	[at.searchKit_Begin]: (state, action) => ({
		...state,
		searchQuery: action.payload.query,
		searchFacet: action.payload.facet,
		searchKitLoading: true,
		searchLoading: true
	}),
	[at.searchKit_Success]: (state, action) => {
		const searchKitResults = action.payload ? action.payload.hits : []
		const payloadQuery = action.payload ? action.payload.query : null
		//	Skip invalid results
		if (payloadQuery !== state.searchQuery) {
			return state
		}

		return {
			...state,
			searchKitResults,
			searchKitLoading: false,
			searchLoading: state.searchItemLoading || state.searchUserLoading
		}
	},
	[at.searchKit_Fail]: (state, action) => ({
		...state,
		searchKitError: action.payload.searchKitError,
		searchKitLoading: false,
		searchLoading: state.searchItemLoading || state.searchUserLoading
	}),

	[at.searchUser_Begin]: (state, action) => ({
		...state,
		searchQuery: action.payload.query,
		searchFacet: action.payload.facet,
		searchUserLoading: true,
		searchLoading: true
	}),
	[at.searchUser_Success]: (state, action) => {
		const searchUserResults = action.payload ? action.payload.hits : []
		const payloadQuery = action.payload ? action.payload.query : null
		//	Skip invalid results
		if (payloadQuery !== state.searchQuery) {
			return state
		}

		return {
			...state,
			searchUserResults,
			searchUserLoading: false,
			searchLoading: state.searchItemLoading || state.searchKitLoading
		}
	},
	[at.searchUser_Fail]: (state, action) => ({
		...state,
		searchUserError: action.payload.searchUserError,
		searchUserLoading: false,
		searchLoading: state.searchItemLoading || state.searchKitLoading
	}),

	/* Search suggestions */
	[at.brandSuggestions.fetch.SUCCESS]: (state, action) => ({
		...state,
		brandSuggestions: action.payload.suggestions
	}),
	[at.jerseyNameSuggestions.fetch.BEGIN]: (state, action) => ({
		...state,
		jerseyNameSuggestions: state.jerseyNameSuggestionsFetchBrandName !== action.payload.brandName || state.jerseyNameSuggestionsFetchGender !== action.payload.gender ? [] : state.jerseyNameSuggestions,
		jerseyNameSuggestionsFetchQuery: action.payload.query,
		jerseyNameSuggestionsFetchBrandName: action.payload.brandName,
		jerseyNameSuggestionsFetchGender: action.payload.gender
	}),
	[at.jerseyNameSuggestions.fetch.SUCCESS]: (state, action) => ({
		...state,
		jerseyNameSuggestions: action.payload.suggestions
	})

})



// WEBPACK FOOTER //
// ./src/redux/reducers/searchReducer.js